// hellyk-theme — theme.js
document.addEventListener('DOMContentLoaded', function() {

  const esc = s => String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  const fmt = n => Number(n).toFixed(2).replace('.',',');

  // ── Ticker ────────────────────────────────────────────────────────────────────
  const tickerMsgs = [...document.querySelectorAll('.ticker-msg')];
  let tickerIdx = 0;
  if (tickerMsgs.length > 1) {
    setInterval(() => {
      tickerMsgs[tickerIdx].classList.add('exit');
      tickerMsgs[tickerIdx].classList.remove('active');
      setTimeout(() => {
        tickerMsgs[tickerIdx].classList.remove('exit');
        tickerIdx = (tickerIdx + 1) % tickerMsgs.length;
        tickerMsgs[tickerIdx].classList.add('active');
      }, 500);
    }, 3800);
  }

  // Ticker close button
  const tickerClose = document.querySelector('.ticker-close');
  const tickerBar = document.getElementById('tickerBar');
  if (tickerClose && tickerBar) {
    tickerClose.addEventListener('click', () => { tickerBar.style.display = 'none'; });
  }

  // ── Hero slider ───────────────────────────────────────────────────────────────
  let hi = 0;
  const slides = [...document.querySelectorAll('.hero-slide')];
  const dots   = [...document.querySelectorAll('.hero-dot')];
  const track  = document.getElementById('heroTrack');

  if (slides.length && track) {
    function goSlide(n) {
      slides[hi].classList.remove('active');
      dots[hi] && dots[hi].classList.remove('active');
      hi = (n + slides.length) % slides.length;
      slides[hi].classList.add('active');
      dots[hi] && dots[hi].classList.add('active');
      track.style.transform = `translateX(-${hi * 100}%)`;
    }

    const heroPrev = document.getElementById('heroPrev');
    const heroNext = document.getElementById('heroNext');
    if (heroPrev) heroPrev.addEventListener('click', () => goSlide(hi - 1));
    if (heroNext) heroNext.addEventListener('click', () => goSlide(hi + 1));
    dots.forEach(d => d.addEventListener('click', () => goSlide(+d.dataset.i)));

    let autoH = setInterval(() => goSlide(hi + 1), 5200);
    const heroSec = document.getElementById('heroSection');
    if (heroSec) {
      heroSec.addEventListener('mouseenter', () => clearInterval(autoH));
      heroSec.addEventListener('mouseleave', () => { clearInterval(autoH); autoH = setInterval(() => goSlide(hi + 1), 5200); });
    }

    let tx = 0;
    track.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend',   e => { const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) goSlide(dx < 0 ? hi + 1 : hi - 1); });
  }

  // ── Parallax on promo banner ──────────────────────────────────────────────────
  const promoBg = document.getElementById('promoBg');
  if (promoBg) {
    const updateParallax = () => {
      const rect = promoBg.parentElement.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const pct = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        promoBg.style.transform = `translateY(${(pct - 0.5) * -50}px)`;
      }
    };
    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  }

  // ── IntersectionObserver — fade-up sections ───────────────────────────────────
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } });
  }, { threshold: 0.07, rootMargin: '0px 0px -32px 0px' });
  document.querySelectorAll('.fade-up').forEach(el => io.observe(el));

  // ── Carousel arrow buttons ────────────────────────────────────────────────────
  function setupArrows(carId, prevId, nextId) {
    const c = document.getElementById(carId);
    if (!c) return;
    const w = () => (c.querySelector('.prod-card')?.offsetWidth || 200) + 18;
    const prevBtn = document.getElementById(prevId);
    const nextBtn = document.getElementById(nextId);
    if (prevBtn) prevBtn.addEventListener('click', () => c.scrollBy({ left: -w() * 3, behavior: 'smooth' }));
    if (nextBtn) nextBtn.addEventListener('click', () => c.scrollBy({ left:  w() * 3, behavior: 'smooth' }));
  }

  // Wire up any carousels that exist in the page
  setupArrows('saleCarousel', 'salePrev', 'saleNext');
  setupArrows('newCarousel',  'newPrev',  'newNext');
  setupArrows('featCarousel', 'featPrev', 'featNext');

  // ── Drill-down config (all main collections) ──────────────────────────────────
  const DRILLDOWN = {
    'gid://shopify/Collection/676225057106': {
      emoji: '🧸', title: 'Mänguasjad', ctaLabel: 'mänguasju',
      tagline: 'Leia sobiv mänguasi igale lapsele ja vanusele',
      subcategories: [
        { emoji: '🪵', label: 'Puidust mänguasjad',    hint: "Grimm's, Ostheimer, Grapat — looduslik ja kestev",  tag: 'Puidust mänguasjad' },
        { emoji: '🪆', label: 'Nukud & kaisukad',       hint: 'Riidest nukud, pehmed kaisukad ja tarvikud',        tag: 'Nukud' },
        { emoji: '🧱', label: 'Klotsid & virnastamine', hint: 'Vikerkaared, magnetklotsid, Stapelstein, CONNETIX', tag: 'klotsid ja virnastamine' },
        { emoji: '🎭', label: 'Rollimäng & kostüümid',  hint: 'Great Pretenders — ehted, kleidid, kroonid',        tag: 'Kostüümid' },
        { emoji: '🧩', label: 'Lauamängud & pusled',    hint: 'Perega mängimine, visuaalsed ja mõttemängud',       tag: 'Lauamängud/mängud' },
        { emoji: '🎨', label: 'Loovus & meisterdamine', hint: 'Joonistamine, voolimine, käsitöö, kleepsud',        tag: 'Joonistustarbed / meisterdamine / käsitöö / kleepsud' },
        { emoji: '👶', label: 'Beebimänguasjad',        hint: 'Kuni 3-aastastele — raputid, tõmmatavad, arendavad',tag: 'Beebimänguasjad' },
        { emoji: '🌳', label: 'Õuemänguasjad',          hint: 'Aktiivsed mängud, seiklus ja liikumine õues',       tag: 'Õuemänguasjad' },
        { emoji: '🚗', label: 'Autod & sõidukid',       hint: 'Mänguautod, retro, Waytoplay teerajad',             tag: 'Erinevad mänguautod' },
        { emoji: '🎵', label: 'Muusika & raamatud',     hint: 'Pillid, muusikakarbid, laste- ja pildiraamatud',    tag: 'Muusika' },
        { emoji: '🍎', label: 'Mängutoit & kauplus',    hint: 'Erzi puidust toit, söögiaeg ja mängupoekaubad',     tag: 'Erzi mängutoit ja tarvikud' },
        { emoji: '🛁', label: 'Vannimänguasjad',        hint: 'Glo Pals, vee- ja suplusmänguasjad',                tag: 'Vannimänguasjad' },
      ],
      brands: ["Grimm's", 'Great Pretenders', 'Moulin Roty', 'Grapat', 'Ostheimer', 'CONNETIX', "Sarah's Silks", 'Waytoplay', 'Stapelstein', 'Wobbel', 'Senger Naturwelt', 'Erzi', 'Glo Pals'],
      spotlight: { vendor: 'CONNETIX', label: 'CONNETIX magnetklotsid', tagline: 'Piiramatute mänguvõimalustega magnetklotsid — ehitage lossi, torne ja 3D kujundeid!' },
    },
    'gid://shopify/Collection/676225417554': {
      emoji: '👕', title: 'Lasteriided', ctaLabel: 'lasteriideid',
      tagline: 'Kvaliteetsed ja mugavad riided lastele — lasteaeda, kooli ja igaks puhuks',
      subcategories: [
        { emoji: '👖', label: 'Püksid & retuusid',      hint: 'Elastsed ja mugavad iga päev kandmiseks',           tag: 'Püksid/retuusid' },
        { emoji: '👚', label: 'Pluusid & särgid',       hint: 'Armsad ja praktilised igapäeva pluusid',            tag: 'Pluusid/särgid' },
        { emoji: '👗', label: 'Kleidid & komplektid',   hint: 'Pidulikust kuni argipäevani',                       tag: 'Kleidid/seelikud/komplektid' },
        { emoji: '🧦', label: 'Sokid & sukkpüksid',     hint: 'Soojad ja kestlikud — villased ja bambusest',       tag: 'Sokid' },
        { emoji: '🧥', label: 'Kampsunid & jakid',      hint: 'Üleminekuperioodiks ja talveks',                    tag: 'Kampsunid, pusad, jakid' },
        { emoji: '🎽', label: "Body'd & maikad",        hint: 'Beebi esimesed rõivad ja alusriided',               tag: "Body'd" },
        { emoji: '🌡️', label: 'Termoriided',            hint: 'Õhuke kuid soe — esimene kiht külmal ilmal',        tag: 'Termoriided' },
        { emoji: '🧢', label: 'Mütsid & kindad',        hint: 'Talvine peakate ja soojad käed',                    tag: 'Mütsid' },
        { emoji: '😴', label: 'Pidžaamad',              hint: 'Pehmed ja hubased öörõivad',                        tag: 'Pidžaamad/öösärgid' },
        { emoji: '🏊', label: 'Ujumisriided',           hint: 'Rannas ja basseinis',                               tag: 'Ujumisriided' },
        { emoji: '❄️', label: 'Talvised õueriided',     hint: 'Kombinesoonid ja muud külmailma riided',            tag: 'Talvised õueriided' },
        { emoji: '👶', label: 'Toakombed & romperid',   hint: 'Beebi esimesed mugavad rõivad',                    tag: 'Toakombed/romperid' },
      ],
      brands: ['Green Cotton', 'Mikk-Line', 'Minymo', 'Boody', "Fred's World", 'Müsli', 'Minimalisma', 'Engel', 'CeLaVi', 'Cosilana'],
      spotlight: { vendor: 'Green Cotton', label: 'Green Cotton', tagline: 'GOTS-sertifitseeritud orgaanilised lasteriided — looduslikust materjalist, armastusega planeedile' },
    },
    'gid://shopify/Collection/676226040146': {
      emoji: '👟', title: 'Laste barefoot-jalatsid', ctaLabel: 'laste barefoot-jalatseid',
      tagline: 'Loomulik jalgade areng alates esimestest sammudest',
      subcategories: [
        { emoji: '🏠', label: 'Sisejalatsid',           hint: 'Lasteaia ja koolisisesed jalatsid',                 tag: 'Sisejalatsid' },
        { emoji: '🌸', label: 'Kevad & sügis',          hint: 'Kerged üleminekuhooaja jalatsid',                   tag: 'Kevad/sügis' },
        { emoji: '☀️', label: 'Sandaalid & kingad',     hint: 'Suviseks avajala tunnetuseks',                      tag: 'Sandaalid ja kingad' },
        { emoji: '❄️', label: 'Talvejalatsid',          hint: 'Sooja voodri ja pidava tallaga',                    tag: 'Talv' },
        { emoji: '🌧️', label: 'Kummikud',              hint: 'Vihma ja loriga mängimiseks',                       tag: 'Kummikud' },
        { emoji: '👶', label: 'Prewalkers',             hint: 'Esimesteks sammudeks — pehmelt ja turvaliselt',     tag: 'Prewalkers' },
        { emoji: '🏃', label: 'Tekstiilist jalatsid',   hint: 'Kerged ja hingatavad spordiks ja argiks',           tag: 'Tekstiilist vabaajajalatsid' },
      ],
      brands: ['D.D.Step', 'Bundgaard', 'Affenzahn', 'Froddo', 'Mikk-Line', 'Baby Bare', 'Tikki', 'Koel'],
      spotlight: { vendor: 'D.D.Step', label: 'D.D.Step jalatsid', tagline: 'Anatoomiliselt korrektne disain lapse loomuliku sammumise ja jalgade tervisliku arengu tagamiseks' },
    },
    'gid://shopify/Collection/676227055954': {
      emoji: '🐑', title: 'Villariided', ctaLabel: 'villariideid',
      tagline: 'Beebidele, lastele ja täiskasvanutele — GOTS-sertifitseeritud meriinovillast',
      subcategories: [
        { emoji: '🧦', label: 'Villased sokid',         hint: 'Soojas püsivad ja hingavad jalad',                  tag: 'Villased sokid' },
        { emoji: '🧣', label: 'Mütsid & sallid',        hint: 'Pea ja kael soojas — stiilselt',                   tag: 'Villased mütsid ja peapaelad' },
        { emoji: '🧤', label: 'Villased kindad',        hint: 'Käed soojas ka kõige külmemal ilmal',               tag: 'Villased kindad' },
        { emoji: '👕', label: 'Villased pluusid',       hint: 'Igapäevane mugav aluskiht',                         tag: 'Villased pluusid' },
        { emoji: '👖', label: 'Villased püksid',        hint: 'Termoregulatsiooni tagavad retuusid',               tag: 'Villased püksid ja retuusid' },
        { emoji: '🧥', label: 'Paksud villased jakid',  hint: 'Sügiseks ja talveks — üliriie',                    tag: 'Paksud villased jakid' },
        { emoji: '👶', label: "Villased body'd",        hint: 'Esimene kiht beebi naha lähedal',                  tag: "Villased body'd" },
        { emoji: '👩', label: 'Naistele',               hint: 'Villased rõivad naistele',                          tag: 'Villariided naistele' },
      ],
      brands: ['Engel', 'Mikk-Line', 'Cosilana', 'Pure Pure by Bauer', 'Melton', 'Disana', 'Minymo'],
      spotlight: { vendor: 'Engel', label: 'Engel meriinovillast', tagline: 'GOTS-sertifitseeritud orgaaniline meriinovillane riidekollektsioon — soe, pehme ja kestvalt valmistatud' },
    },
    'gid://shopify/Collection/676224762194': {
      emoji: '🧴', title: 'Hooldusvahendid & kosmeetika', ctaLabel: 'hooldusvahendeid',
      tagline: 'Looduslik nahahooldus, juuksehooldus ja aksessuaarid kogu perele',
      subcategories: [
        { emoji: '🧼', label: 'Nahahooldus & hügieen',  hint: 'Looduslik ja leebe igapäevahooldus',                tag: 'Nahahooldus ja hügieen' },
        { emoji: '😎', label: 'Päikeseprillid',         hint: 'UV-kaitsega stiilsed prillid lastele ja täisk.',   tag: 'Päikeseprillid' },
        { emoji: '💇', label: 'Juuksehooldus',          hint: 'Šampoonid, palsamid ja juuksemaskid',              tag: 'Juuksehooldus' },
        { emoji: '👕', label: 'Riiete hooldus',         hint: 'Ökoloogilised pesuained ja hooldus',                tag: 'Riiete hooldus ja tarvikud' },
        { emoji: '🏠', label: 'Koduhooldus',            hint: 'Loodussõbralikud puhastusvahendid',                 tag: 'Koduhooldus ja tarvikud' },
        { emoji: '👟', label: 'Jalatsite hooldus',      hint: 'Impregneerivad ja hooldavad vahendid',              tag: 'Jalatsite hooldus ja tarvikud' },
      ],
      brands: ['Kietla', 'Ecoegg', 'Gogonano', 'Konges Sløjd', 'Pure Beginnings', 'Souldrops', 'Alphanova Sun'],
      spotlight: { vendor: 'Kietla', label: 'Kietla päikeseprillid', tagline: 'Stiilsed ja ohutud UV-kaitsega päikeseprillid — beebidest täiskasvanuteni' },
    },
    'gid://shopify/Collection/678848004434': {
      emoji: '🏷️', title: 'Outlet riided', ctaLabel: 'outlet tooteid',
      tagline: 'Kvaliteetsed riided soodsate hindadega — kogused on piiratud!',
      subcategories: [
        { emoji: '👕', label: 'Lasteriided outlet',     hint: 'Laste igapäevariided alandatud hindadega',          tag: 'Lasteriided' },
        { emoji: '👩', label: 'Naistele outlet',        hint: 'Naiste rõivad soodsamalt',                          tag: 'Naistele' },
        { emoji: '🐑', label: 'Villariided outlet',     hint: 'Vill ja meriinovillast mood allahindlusega',         tag: 'Villariided' },
        { emoji: '👗', label: 'Kleidid & komplektid',   hint: 'Pidulikud ja argsed kleidid',                       tag: 'Kleidid/seelikud/komplektid' },
        { emoji: '👖', label: 'Püksid & retuusid',      hint: 'Mugavad püksid heades toonides',                    tag: 'Püksid/retuusid' },
        { emoji: '🎽', label: "Body'd & särgikud",      hint: 'Aluskirhid ja kerge riie',                          tag: "Body'd" },
      ],
      brands: ['Green Cotton', 'Name It', 'Mikk-Line', 'Boody', 'Minymo', "Fred's World", 'Thought', 'Wheat', 'Müsli', 'Engel'],
      spotlight: null,
    },
    'gid://shopify/Collection/676226859346': {
      emoji: '👩', title: 'Naistele', ctaLabel: 'naiste tooteid',
      tagline: 'Ökoloogiline ja mugav moevalik naistele — igapäevaseks kandmiseks',
      subcategories: [
        { emoji: '🩱', label: 'Pesu & alusriided',      hint: 'Pehme bambusest ja meriinovillast',                 tag: 'Pesu' },
        { emoji: '👚', label: 'Pluusid & kampsunid',    hint: 'Klassikalisest lihtsast stiilseni',                 tag: 'Pluusid/särgid/kampsunid' },
        { emoji: '🎽', label: 'Särgikud & maikad',      hint: 'Kerged ja hingavad igapäevaks',                     tag: 'Särgikud/maikad' },
        { emoji: '🧦', label: 'Sokid',                  hint: 'Bambusest, villasest ja ökoloogilisest materjalist',tag: 'Sokid naistele' },
        { emoji: '🧥', label: 'Üleriided',              hint: 'Jakid ja mantlid üleminekuhooajaks',                tag: 'Üleriided' },
        { emoji: '🐑', label: 'Villariided naistele',   hint: 'Soe ja looduslik villarõivas',                      tag: 'Villariided naistele' },
      ],
      brands: ['Boody', 'Thought', 'Engel', 'Konges Sløjd', 'BeLenka', 'Soyaconcept'],
      spotlight: { vendor: 'Boody', label: 'Boody bambusrõivad', tagline: 'Ülimalt pehme bambusest aluspesu ja rõivad — ökoloogiline, mugav ja jätkusuutlikult toodetud' },
    },
    'gid://shopify/Collection/676225483090': {
      emoji: '🏡', title: 'Kodumaailm & tarvikud', ctaLabel: 'kodumaailma tooteid',
      tagline: 'Kodu-, beebi- ja reisitarvikud — funktsionaalsed ja ilusad',
      subcategories: [
        { emoji: '🍽️', label: 'Söögiaeg & tarvikud',   hint: 'Söötmisalused, söögiriistad ja muud tarvikud',      tag: 'Söögiaeg ja tarvikud' },
        { emoji: '🛌', label: 'Tekid & musliinrätikud', hint: 'Pehmed ja hingavad musliinist',                      tag: 'Tekid / musliinrätid' },
        { emoji: '🛍️', label: 'Kotid & poekotid',      hint: 'Kott igaks elunurgaks — pood, reis, kosmeetika',    tag: 'Poekotid/ hoiukotid/ toidukotid' },
        { emoji: '🍼', label: 'Beebitarvikud',          hint: 'Lutihoidjad, mähkmekotid ja pesad',                  tag: 'Lutihoidjad' },
        { emoji: '🛏️', label: 'Voodipesu',             hint: 'Loodussõbralik ja hingav voodipesu',                 tag: 'Voodipesu' },
      ],
      brands: ['Moulin Roty', 'Mushie', 'Konges Sløjd', 'Elodie Details', 'Voksi', 'Sass&Belle'],
      spotlight: { vendor: 'Mushie', label: 'Mushie beebitarvikud', tagline: 'Skandinaavia minimalistlik disain — turvalised, lihtsad ja armsad beebitarvikud' },
    },
    'gid://shopify/Collection/676228399442': {
      emoji: '🪆', title: 'Nukud & tarvikud', ctaLabel: 'nukke ja tarvikuid',
      tagline: 'Realistlikud nukud, rõivad ja nukuvankrid armsateks rollimängudeks',
      subcategories: [
        { emoji: '🪆', label: 'Nukud',                  hint: 'Riidest ja pehmed kaisunukud lastele',              tag: 'Nukud' },
        { emoji: '👗', label: 'Nukuriided & aksessuaarid',hint: 'Moekad rõivad armastatud nukkudele',              tag: 'Nukuriided ja aksessuaarid' },
        { emoji: '🛒', label: 'Nukuvankrid & kärud',    hint: 'Jalutuskäikudeks ja rollimängudeks',                tag: 'Nukuvankrid ja kärud' },
        { emoji: '🧸', label: 'Kaisukad & kaltsunukud', hint: 'Pehmed sõbrad ööks ja päevaks',                    tag: 'Kaisukad ja kaltsunukud' },
        { emoji: '🎁', label: 'Muud tarvikud',          hint: 'Kõik vajalik nuku elu täiustamiseks',               tag: 'Muud tarvikud nukkudele' },
      ],
      brands: ['Minikane', 'Götz', 'Paola Reina', 'Konges Sløjd', 'Frisette'],
      spotlight: { vendor: 'Minikane', label: 'Minikane nukud', tagline: 'Prantsuse disainiga realistlikud kaisunukud — ilusad, pehmed ja kõrge kvaliteediga detailid' },
    },
    'gid://shopify/Collection/676226957650': {
      emoji: '🦶', title: 'Täiskasvanute barefoot-jalatsid', ctaLabel: 'barefoot-jalatseid',
      tagline: 'Tervislikud jalatsid täiskasvanutele — kõnnid justkui paljajalu',
      subcategories: [
        { emoji: '🏠', label: 'Sisejalatsid & suvi',    hint: 'Kerged kontoritossud ja suvised sandaalid',         tag: 'Sisejalats/suvi' },
        { emoji: '🌸', label: 'Kevad & sügis',          hint: 'Üleminekuhooaja lemmikjalatsid',                    tag: 'Kevad/sügis' },
        { emoji: '❄️', label: 'Talvejalatsid',          hint: 'Soojas püsid ka kõige külmemal päeval',             tag: 'Talv' },
        { emoji: '🌧️', label: 'Kummikud',              hint: 'Vihmane ilm? Pole probleemi!',                      tag: 'Kummikud' },
        { emoji: '🏖️', label: 'Basseinisussid',         hint: 'Basseinis ja rannas',                               tag: 'Basseinisussid suurtele' },
      ],
      brands: ['BeLenka', 'Vivobarefoot', 'Xero', 'Leguano', 'Bundgaard', 'Joe Nimble', 'Tikki', 'Froddo', 'Shapen'],
      spotlight: { vendor: 'BeLenka', label: 'BeLenka barefoot', tagline: 'Slovakkia käsitöö — ultra-õhukese talla ja laiatippolise kipsiga täiuslik barefoot jalats' },
    },
    'gid://shopify/Collection/676226924882': {
      emoji: '👨', title: 'Meestele', ctaLabel: 'meeste tooteid',
      tagline: 'Ökoloogilised ja mugavad rõivad meestele — looduslikest materjalidest',
      subcategories: [
        { emoji: '🩲', label: 'Pesu & alusriided',      hint: 'Pehme bambusest ja meriinovillast',                 tag: 'Pesu' },
        { emoji: '🧦', label: 'Sokid',                  hint: 'Bambusest ja villast kvaliteedisokid',              tag: 'Sokid meestele' },
        { emoji: '👕', label: 'Pluusid & maikad',       hint: 'Igapäevased mugavad riided',                        tag: 'Pluusid/särgid/maikad' },
        { emoji: '🧥', label: 'Üleriided',              hint: 'Jakid ja mantlid üleminekuhooajaks',                tag: 'Üleriided' },
        { emoji: '🌂', label: 'Vihmavarjud & keebid',   hint: 'Kaalutu ja kompaktne vihmakaitse',                  tag: 'Vihmavarjud ja -keebid' },
        { emoji: '🐑', label: 'Villariided meestele',   hint: 'Looduslik ja soe meriinovillane kiht',              tag: 'Villariided meestele' },
      ],
      brands: ['Boody', 'Engel', 'Thought', 'Vegateksa', 'BeLenka', 'Rainkiss'],
      spotlight: { vendor: 'Boody', label: 'Boody meestele', tagline: 'Bambusest ökoloogiline meeste aluspesu ja sokid — ülimalt pehme, hingav ja jätkusuutlik' },
    },
  };

  // ── Drill-down panel ──────────────────────────────────────────────────────────
  // Panel is already rendered in the HTML by featured-categories.liquid
  const ddPanel = document.getElementById('ddBackdrop');
  if (ddPanel) {
    document.getElementById('ddClose').addEventListener('click', closeDrilldown);
    ddPanel.addEventListener('click', e => { if (e.target === ddPanel) closeDrilldown(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrilldown(); });
  }

  // Convert a tag string to Shopify's URL handle format (like Liquid | handleize)
  function handleize(str) {
    return str.toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/õ/g, 'o').replace(/š/g, 's').replace(/ž/g, 'z')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // GID → collection handle mapping for Shopify storefront product fetch
  const GID_TO_HANDLE = {
    'gid://shopify/Collection/676225057106': 'manguasjad',
    'gid://shopify/Collection/676225417554': 'lasteriided',
    'gid://shopify/Collection/676226040146': 'laste-barefoot-jalatsid',
    'gid://shopify/Collection/676227055954': 'villariided',
    'gid://shopify/Collection/676224762194': 'hooldusvahendid',
    'gid://shopify/Collection/678848004434': 'outlet',
    'gid://shopify/Collection/676226859346': 'naistele',
    'gid://shopify/Collection/676225483090': 'kodu-lapsed-ja-vaba-aeg',
    'gid://shopify/Collection/676228399442': 'nukud-ja-tarvikud',
    'gid://shopify/Collection/676226957650': 'taiskasvanute-barefoot-jalatsid',
    'gid://shopify/Collection/676226924882': 'meestele',
  };


  function openDrilldown(collectionId) {
    const cfg = DRILLDOWN[collectionId];
    if (!cfg || !ddPanel) return;

    document.getElementById('ddEmoji').textContent   = cfg.emoji;
    document.getElementById('ddTitle').textContent   = cfg.title;
    document.getElementById('ddTagline').textContent = cfg.tagline;
    document.getElementById('ddCtaText').textContent = `Kuva kõik ${cfg.ctaLabel || cfg.title.toLowerCase()}`;
    document.getElementById('ddCta').href = `/collections/${GID_TO_HANDLE[collectionId] || '#'}`;

    const colHandle = GID_TO_HANDLE[collectionId] || '';
    document.getElementById('ddSubcats').innerHTML = cfg.subcategories.map(s => {
      // Use Shopify's clean tag URL: /collections/handle/tag-handle
      // This matches how the sidebar filter links work, so the sidebar shows the active state
      const tagUrl = colHandle
        ? `/collections/${colHandle}/${handleize(s.tag)}`
        : `/search?type=product&q=${encodeURIComponent(s.tag)}`;
      return `<a class="dd-card" href="${esc(tagUrl)}">
        <span class="dd-card-emoji">${s.emoji}</span>
        <span class="dd-card-label">${esc(s.label)}</span>
        <span class="dd-card-hint">${esc(s.hint)}</span>
      </a>`;
    }).join('');

    if (cfg.brands && cfg.brands.length) {
      document.getElementById('ddBrands').innerHTML = cfg.brands.map(b =>
        `<a class="dd-brand-chip" href="/search?type=product&q=${encodeURIComponent(b)}&filter.p.vendor=${encodeURIComponent(b)}">${esc(b)}</a>`).join('');
      document.getElementById('ddBrandsWrap').style.display = '';
    } else {
      document.getElementById('ddBrandsWrap').style.display = 'none';
    }

    const featContent = document.getElementById('ddFeatContent');
    document.getElementById('ddFeaturedWrap').style.display = '';
    featContent.innerHTML = '<div class="dd-feat-loading"><span></span><span></span><span></span><span></span></div>';

    const handle = GID_TO_HANDLE[collectionId] || collectionId;

    // Fetch the real collection page and extract already-rendered product cards.
    // This gives us variants, ESTO, ATC buttons, OOS filtering — everything from Liquid.
    fetch(`/collections/${handle}?filter.v.availability=1`)
      .then(r => r.text())
      .then(html => {
        const doc   = new DOMParser().parseFromString(html, 'text/html');
        const cards = doc.querySelectorAll('#productGrid .prod-card-wrap');
        if (!cards.length) {
          document.getElementById('ddFeaturedWrap').style.display = 'none';
          return;
        }
        // Build spotlight HTML if configured
        let spotlightHtml = '';
        if (cfg.spotlight) {
          spotlightHtml = `<div class="dd-spotlight">
            <div class="dd-spotlight-inner">
              <span class="dd-spotlight-badge">⭐ Populaarseim</span>
              <strong class="dd-spotlight-name">${esc(cfg.spotlight.label)}</strong>
              <p class="dd-spotlight-desc">${esc(cfg.spotlight.tagline)}</p>
            </div>
            <a class="dd-spotlight-btn" href="/search?type=product&q=${encodeURIComponent(cfg.spotlight.vendor)}&filter.p.vendor=${encodeURIComponent(cfg.spotlight.vendor)}">Vaata &rarr;</a>
          </div>`;
        }
        // Wrap each card in a slide
        const slides = Array.from(cards).slice(0, 10).map(card => {
          const slide = document.createElement('div');
          slide.className = 'dd-feat-slide';
          slide.appendChild(card.cloneNode(true));
          return slide.outerHTML;
        }).join('');

        featContent.innerHTML = spotlightHtml + `
          <div class="dd-feat-carousel-wrap">
            <button class="dd-feat-arr prev" onclick="ddFeatNav(this,-1)" aria-label="Eelmine" style="opacity:.3">&#8592;</button>
            <div class="dd-feat-viewport"><div class="dd-feat-track" id="ddFeatTrack">${slides}</div></div>
            <button class="dd-feat-arr next" onclick="ddFeatNav(this,1)" aria-label="Järgmine">&#8594;</button>
          </div>`;

        // Add touch swipe to popup carousel
        const track = document.getElementById('ddFeatTrack');
        if (track) {
          let tx = 0;
          track.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
          track.addEventListener('touchend', e => {
            const dx = e.changedTouches[0].clientX - tx;
            if (Math.abs(dx) > 40) {
              const btn = track.closest('.dd-feat-carousel-wrap').querySelector(dx < 0 ? '.dd-feat-arr.next' : '.dd-feat-arr.prev');
              if (btn) ddFeatNav(btn, dx < 0 ? 1 : -1);
            }
          }, { passive: true });
        }
      })
      .catch(() => { document.getElementById('ddFeaturedWrap').style.display = 'none'; });

    ddPanel.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      ddPanel.classList.add('dd-open');
      document.getElementById('ddPanel').classList.add('dd-panel-open');
    });
  }

  window.ddFeatNav = function(btn, dir) {
    const track  = btn.closest('.dd-feat-carousel-wrap').querySelector('.dd-feat-track');
    const slides = track.querySelectorAll('.dd-feat-slide');
    if (!slides.length) return;
    const cur = parseInt(track.dataset.idx || '0');
    const visible = window.innerWidth >= 700 ? 4 : 2;
    const max = Math.max(0, slides.length - visible);
    const next = Math.min(Math.max(cur + dir, 0), max);
    track.dataset.idx = next;
    const w = slides[0].offsetWidth + parseInt(getComputedStyle(track).gap || '0');
    track.style.transform = 'translateX(-' + (next * w) + 'px)';
    btn.closest('.dd-feat-carousel-wrap').querySelector('.dd-feat-arr.prev').style.opacity = next === 0   ? '.3' : '1';
    btn.closest('.dd-feat-carousel-wrap').querySelector('.dd-feat-arr.next').style.opacity = next >= max  ? '.3' : '1';
  };

  function closeDrilldown() {
    if (!ddPanel) return;
    ddPanel.classList.remove('dd-open');
    document.getElementById('ddPanel').classList.remove('dd-panel-open');
    document.body.style.overflow = '';
    setTimeout(() => { ddPanel.style.display = 'none'; }, 350);
  }

  // Delegate click on drill tiles
  document.addEventListener('click', e => {
    const tile = e.target.closest('[data-drill]');
    if (!tile) return;
    e.preventDefault();
    openDrilldown(tile.dataset.drill);
  });

}); // end DOMContentLoaded

/* ── Lazy video loader ─────────────────────────────────────────────────────
   Hero video (inside .hero-slide.active) loads eagerly — it's above the fold.
   Every other <video> on the page starts with preload="none" so the browser
   downloads nothing until the element is about to scroll into view.
   IntersectionObserver triggers 200px before the video enters the viewport,
   sets preload="auto" and calls play() so it's ready right on time.
──────────────────────────────────────────────────────────────────────────── */
(function () {
  // Find all video elements on the page
  const allVideos = Array.from(document.querySelectorAll('video'));
  if (!allVideos.length) return;

  // The hero active slide video should play immediately — leave it alone
  const heroActiveVideo = document.querySelector('.hero-slide.active video');

  // All other videos get deferred
  const lazyVideos = allVideos.filter(v => v !== heroActiveVideo);
  if (!lazyVideos.length) return;

  // Set preload="none" so browser downloads nothing yet
  lazyVideos.forEach(v => {
    v.preload = 'none';
    v.pause();
  });

  if (!('IntersectionObserver' in window)) {
    // Fallback for very old browsers — just load everything
    lazyVideos.forEach(v => { v.preload = 'auto'; v.play().catch(() => {}); });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      video.preload = 'auto';
      video.load(); // trigger the browser to start downloading
      video.play().catch(() => {}); // autoplay (muted, so allowed)
      observer.unobserve(video); // only need to trigger once
    });
  }, {
    rootMargin: '200px 0px', // start loading 200px before entering viewport
    threshold: 0
  });

  lazyVideos.forEach(v => observer.observe(v));
})();

/* ── Customer colour theme switcher ──────────────────────────────────────── */
(function () {
  var STORAGE_KEY = 'hellyk-color-theme';
  var THEMES = ['looduslik', 'roosa', 'kuldne', 'virsik'];
  var DEFAULT_THEME = document.documentElement.getAttribute('data-hellyk-theme') || 'looduslik';

  var switcher  = document.getElementById('hdrThemeSwitcher');
  var btn       = document.getElementById('hdrThemeBtn');
  var dropdown  = document.getElementById('hdrThemeDropdown');
  var resetBtn  = document.getElementById('hdrThemeReset');
  if (!switcher || !btn) return;

  /* Apply theme to both <html> and <body> */
  function applyTheme(theme) {
    var els = [document.documentElement, document.body];
    els.forEach(function (el) {
      THEMES.forEach(function (t) { el.classList.remove('theme-' + t); });
      el.classList.add('theme-' + theme);
    });
    document.documentElement.setAttribute('data-hellyk-theme', theme);
    // Update active state in desktop dropdown
    if (dropdown) dropdown.querySelectorAll('.hdr-theme-option').forEach(function (opt) {
      opt.classList.toggle('active', opt.dataset.theme === theme);
    });
    // Update active state in mobile swatches
    document.querySelectorAll('.mob-theme-swatch').forEach(function (s) {
      s.classList.toggle('active', s.dataset.theme === theme);
    });
  }
  // Expose globally so mobile swatches can call it
  window.hellykApplyTheme = function(theme) {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch(e) {}
    applyTheme(theme);
  };
  window.hellykResetTheme = function() {
    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
    applyTheme(DEFAULT_THEME);
  };

  /* Toggle dropdown */
  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    switcher.classList.toggle('open');
  });

  /* Close on outside click */
  document.addEventListener('click', function (e) {
    if (!switcher.contains(e.target)) switcher.classList.remove('open');
  });

  /* Select a theme */
  dropdown.querySelectorAll('.hdr-theme-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var theme = opt.dataset.theme;
      try { localStorage.setItem(STORAGE_KEY, theme); } catch (e) {}
      applyTheme(theme);
      switcher.classList.remove('open');
    });
  });

  /* Reset to admin default */
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      applyTheme(DEFAULT_THEME);
      switcher.classList.remove('open');
    });
  }

  /* Set initial active state */
  var current = (function () {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  })() || DEFAULT_THEME;
  applyTheme(current);
})();

/* ── Mega menu tag list interactions ─────────────────────────────────────── */
(function () {
  function initMegaTags(root) {
    var scope = root || document;
    scope.querySelectorAll('.hdr-mega-tags[data-tags-mode]').forEach(function (ul) {
      if (ul.dataset.tagsInited) return;   // already initialised — skip
      ul.dataset.tagsInited = '1';
      const mode = ul.dataset.tagsMode;
      const items = Array.from(ul.querySelectorAll('li'));
      if (items.length < 2) return;

      if (mode === 'paginate') initPaginate(ul, items);
      else if (mode === 'expand') initExpand(ul, items);
      else if (mode === 'fade') initFade(ul, items);
    });
  }
  // Expose so the lazy-load fetch can reinitialise injected content
  window.hellykInitMegaTags = initMegaTags;

  /* ── A: Arrow pagination with scroll fallback ── */
  function initPaginate(ul, items) {
    const perPage = parseInt(ul.dataset.tagsPerPage) || 12;
    if (items.length <= perPage) return;
    let page = 0;
    let scrollMode = false;
    const total = Math.ceil(items.length / perPage);
    const rowH = 22; // px per tag row

    // Clip height for pagination
    ul.style.maxHeight = (perPage * rowH) + 'px';
    ul.style.overflow = 'hidden';

    // Wrap in fade container
    const wrap = document.createElement('div');
    wrap.className = 'hdr-tags-page-wrap';
    ul.parentNode.insertBefore(wrap, ul);
    wrap.appendChild(ul);

    // Side hint arrow — now a real clickable button that goes to next page
    const hint = document.createElement('button');
    hint.className = 'hdr-tags-page-hint';
    hint.innerHTML = '&#8250;';
    hint.setAttribute('aria-label', 'Järgmine leht');
    hint.addEventListener('click', function () {
      if (page < total - 1) showPage(page + 1);
    });
    wrap.appendChild(hint);

    /* ── Pagination mode ── */
    function showPage(p) {
      page = p;
      items.forEach(function (li, i) {
        li.hidden = i < p * perPage || i >= (p + 1) * perPage;
      });
      prevBtn.disabled = p === 0;
      nextBtn.disabled = p === total - 1;
      wrap.classList.toggle('last-page', p === total - 1);
      label.classList.toggle('hidden', p === total - 1);
      label.textContent = p === 0 ? 'Vaata rohkem' : (p === total - 1 ? '' : 'Järgmine leht');
      // Hide side hint on last page
      hint.style.display = p === total - 1 ? 'none' : '';
    }

    /* ── Enter scroll mode on mousewheel ── */
    function enterScrollMode() {
      if (scrollMode) return;
      scrollMode = true;
      items.forEach(function (li) { li.hidden = false; });
      ul.style.maxHeight = '260px';
      ul.style.overflowY = 'auto';
      nav.style.display = 'none';
      hint.style.display = 'none';
      wrap.classList.add('scroll-mode');
      wrap.classList.remove('last-page');
    }

    /* ── Return to pagination on scroll-to-top ── */
    ul.addEventListener('scroll', function () {
      if (!scrollMode) return;
      wrap.classList.toggle('scrolled-down', ul.scrollTop > 8);
      if (ul.scrollTop === 0) {
        scrollMode = false;
        ul.style.maxHeight = (perPage * rowH) + 'px';
        ul.style.overflowY = 'hidden';
        wrap.classList.remove('scroll-mode', 'scrolled-down');
        nav.style.display = '';
        showPage(0);
      }
    });

    /* Trigger scroll mode on wheel down */
    wrap.addEventListener('wheel', function (e) {
      if (!scrollMode && e.deltaY > 0) {
        enterScrollMode();
        ul.scrollTop += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    /* ── Pager bar ── */
    const nav = document.createElement('div');
    nav.className = 'hdr-tags-pager';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'hdr-tags-pager-btn';
    prevBtn.innerHTML = '&#8249;';
    prevBtn.title = 'Eelmine';
    prevBtn.addEventListener('click', function () { if (page > 0) showPage(page - 1); });

    const label = document.createElement('span');
    label.className = 'hdr-tags-pager-label';
    label.style.cursor = 'pointer';
    label.addEventListener('click', function () { if (page < total - 1) showPage(page + 1); });

    const nextBtn = document.createElement('button');
    nextBtn.className = 'hdr-tags-pager-btn';
    nextBtn.innerHTML = '&#8250;';
    nextBtn.title = 'Järgmine';
    nextBtn.addEventListener('click', function () { if (page < total - 1) showPage(page + 1); });

    nav.appendChild(prevBtn);
    nav.appendChild(label);
    nav.appendChild(nextBtn);
    // If inside a mobile accordion wrap, append pager inside the wrap so scrollHeight is correct
    if (ul.dataset.pagerInside) {
      wrap.parentNode.appendChild(nav);
    } else {
      wrap.after(nav);
    }
    showPage(0);
  }

  /* ── B: Vaata rohkem expand button ── */
  function initExpand(ul, items) {
    const initial = parseInt(ul.dataset.tagsInitial) || 8;
    if (items.length <= initial) return;

    items.forEach(function (li, i) { li.hidden = i >= initial; });

    const remaining = items.length - initial;
    const btn = document.createElement('button');
    btn.className = 'hdr-tags-more';
    btn.innerHTML =
      '<span class="hdr-tags-more-label">Vaata rohkem</span>' +
      '<span class="hdr-tags-more-badge">+' + remaining + '</span>' +
      '<span class="hdr-tags-more-arrow">›</span>';

    btn.addEventListener('click', function () {
      const isExpanded = btn.classList.contains('expanded');
      if (isExpanded) {
        items.forEach(function (li, i) { li.hidden = i >= initial; });
        btn.classList.remove('expanded');
        btn.querySelector('.hdr-tags-more-label').textContent = 'Vaata rohkem';
        btn.querySelector('.hdr-tags-more-badge').textContent = '+' + remaining;
      } else {
        items.forEach(function (li) { li.hidden = false; });
        btn.classList.add('expanded');
        btn.querySelector('.hdr-tags-more-label').textContent = 'Peida';
        btn.querySelector('.hdr-tags-more-badge').textContent = '';
      }
    });

    ul.after(btn);
  }

  /* ── C: Gradient fade with count badge ── */
  function initFade(ul, items) {
    const initial = parseInt(ul.dataset.tagsInitial) || 6;
    if (items.length <= initial) return;

    const itemHeight = 22; // approx px per tag row
    const fadeHeight = initial * itemHeight;

    // Wrap in fade container
    const wrap = document.createElement('div');
    wrap.className = 'hdr-tags-fade-wrap';
    wrap.style.setProperty('--fade-height', fadeHeight + 'px');
    ul.parentNode.insertBefore(wrap, ul);
    wrap.appendChild(ul);

    const remaining = items.length - initial;
    const btn = document.createElement('button');
    btn.className = 'hdr-tags-fade-btn';
    btn.innerHTML =
      '<span class="hdr-tags-fade-btn-text">+ rohkem</span>' +
      '<span class="hdr-tags-fade-btn-count">' + remaining + '</span>' +
      '<span class="hdr-tags-fade-btn-arrow">→</span>';

    btn.addEventListener('click', function () {
      wrap.classList.add('expanded');
      btn.remove();
    });

    wrap.after(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initMegaTags(); });
  } else {
    initMegaTags();
  }
  // Re-run after Shopify Customizer reloads a section
  document.addEventListener('shopify:section:load', function (e) {
    initMegaTags(e.target);
  });
})();

/* ── Lock body scroll when mega menu is open ──────────────────────────────── */
(function () {
  function init() {
    var megaItems = document.querySelectorAll('.hdr-has-mega');
    var closeTimer = null;
    var DELAY = 250; // ms grace period when mouse leaves nav link toward panel

    function openPanel(item) {
      clearTimeout(closeTimer);
      // Init tag pagination on first open (guard: skip if already initialised)
      var panel = item.querySelector('.hdr-mega');
      if (panel && !panel.dataset.tagsInited) {
        panel.dataset.tagsInited = '1';
        if (window.hellykInitMegaTags) window.hellykInitMegaTags(panel);
      }
      item.classList.add('mega-panel-open');
      document.body.classList.add('mega-open');
    }

    function scheduleClose(item) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove('mega-panel-open');
        document.body.classList.remove('mega-open');
      }, DELAY);
    }

    megaItems.forEach(function (item) {
      var panel = item.querySelector('.hdr-mega');

      item.addEventListener('mouseenter', function () { openPanel(item); });
      item.addEventListener('mouseleave', function () { scheduleClose(item); });

      if (panel) {
        panel.addEventListener('mouseenter', function () { openPanel(item); });
        panel.addEventListener('mouseleave', function () { scheduleClose(item); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { init(); });
})();

/* ── Sidebar category nav (collection + search pages) ──────────────────────── */
(function () {
  function buildMegaNav() {
    var navEl  = document.getElementById('colMegaNav');
    if (!navEl) return;
    var dataEl = document.getElementById('hellyk-mega-data');
    if (!dataEl) return;

    var colHandle  = navEl.dataset.collection || '';
    var activeTags = navEl.dataset.tags ? navEl.dataset.tags.split('|').filter(Boolean) : [];
    var allGroups  = Array.from(dataEl.querySelectorAll('.mega-sbd-group'));
    if (!allGroups.length) return;

    // Find active group — current collection is a category OR a child link
    var activeGroup = colHandle ? allGroups.find(function (g) { return g.dataset.handle === colHandle; }) : null;
    if (!activeGroup && colHandle) {
      var childLink = dataEl.querySelector('a[data-col="' + colHandle + '"]');
      if (childLink) activeGroup = childLink.closest('.mega-sbd-group');
    }

    function buildItem(group, expanded) {
      var title  = group.dataset.title;
      var url    = group.dataset.url;
      var icon   = group.dataset.icon;
      var links  = Array.from(group.querySelectorAll('a'));

      var wrap = document.createElement('div');
      wrap.className = 'cmn-item' + (group === activeGroup ? ' cmn-active' : '') + (expanded ? ' cmn-open' : '');

      var head = document.createElement('div');
      head.className = 'cmn-head';

      var titleLink = document.createElement('a');
      titleLink.href = url;
      titleLink.className = 'cmn-title';
      if (icon) {
        var ic = document.createElement('span');
        ic.className = 'col-mega-nav-emoji';
        ic.textContent = icon;
        titleLink.appendChild(ic);
      }
      var tt = document.createElement('span');
      tt.textContent = title;
      titleLink.appendChild(tt);
      head.appendChild(titleLink);

      if (links.length) {
        var chevron = document.createElement('button');
        chevron.className = 'cmn-chevron';
        chevron.setAttribute('aria-label', 'Laienda');
        chevron.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
        chevron.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = wrap.classList.contains('cmn-open');
          wrap.classList.toggle('cmn-open', !isOpen);
          var body = wrap.querySelector('.cmn-body');
          body.style.maxHeight = isOpen ? '0' : body.scrollHeight + 'px';
        });
        head.appendChild(chevron);
      }
      wrap.appendChild(head);

      if (links.length) {
        var body = document.createElement('div');
        body.className = 'cmn-body';
        body.style.maxHeight = expanded ? '9999px' : '0';

        var i = 0;
        while (i < links.length) {
          var a    = links[i];
          var tag  = a.dataset.tag  || '';
          var colH = a.dataset.col  || '';
          var hasSubs = a.dataset.hasSubs === '1';
          var isLinkActive = (colH && colH === colHandle) || (tag && activeTags.indexOf(tag) !== -1);

          if (hasSubs) {
            // Collect following sub-items
            let subLinks = [];
            let j = i + 1;
            while (j < links.length && links[j].dataset.sub === '1') {
              subLinks.push(links[j]);
              j++;
            }

            // Parent row with expand button
            let parentRow = document.createElement('div');
            parentRow.className = 'cmn-sub-parent' + (isLinkActive ? ' active' : '');

            let lnk = document.createElement('a');
            lnk.href = a.getAttribute('href');
            lnk.className = 'col-mega-nav-link';
            lnk.innerHTML = '<span class="col-mega-nav-arrow">›</span>'
                          + '<span class="col-mega-nav-label">' + a.textContent.trim() + '</span>';
            parentRow.appendChild(lnk);

            let subList = document.createElement('div');
            subList.className = 'cmn-sub-list';
            subLinks.forEach(function (sa) {
              var subColH = sa.dataset.col || '';
              var isSubActive = subColH && subColH === colHandle;
              var sl = document.createElement('a');
              sl.href = sa.getAttribute('href');
              sl.className = 'col-mega-nav-link cmn-sub-link' + (isSubActive ? ' active' : '');
              sl.innerHTML = '<span class="col-mega-nav-arrow">–</span>'
                           + '<span class="col-mega-nav-label">' + sa.textContent.trim() + '</span>';
              subList.appendChild(sl);
            });

            let expandBtn = document.createElement('button');
            expandBtn.className = 'cmn-sub-expand';
            expandBtn.setAttribute('aria-label', 'Laienda');
            expandBtn.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
            expandBtn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              const isOpen = parentRow.classList.contains('cmn-sub-open');
              // Close all other open sub-parents in the same body
              if (!isOpen && body) {
                body.querySelectorAll('.cmn-sub-parent.cmn-sub-open').forEach(function (other) {
                  if (other === parentRow) return;
                  other.classList.remove('cmn-sub-open');
                  var otherList = other.querySelector('.cmn-sub-list');
                  var otherBtn  = other.querySelector('.cmn-sub-expand');
                  if (otherList) otherList.style.maxHeight = '0';
                  if (otherBtn)  otherBtn.setAttribute('aria-expanded', 'false');
                });
              }
              parentRow.classList.toggle('cmn-sub-open', !isOpen);
              subList.style.maxHeight = isOpen ? '0' : subList.scrollHeight + 'px';
              expandBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
              // Update parent cmn-body maxHeight to accommodate expanded sub-list
              if (body) {
                body.style.maxHeight = body.scrollHeight
                  + (isOpen ? 0 : subList.scrollHeight) + 'px';
              }
            });
            // Auto-open if a sub is active
            const anySubActive = colHandle && subLinks.some(function(sa) { return sa.dataset.col === colHandle; });
            if (anySubActive) {
              parentRow.classList.add('cmn-sub-open');
              subList.style.maxHeight = '9999px';
            } else {
              subList.style.maxHeight = '0';
            }

            parentRow.appendChild(expandBtn);
            parentRow.appendChild(subList);
            body.appendChild(parentRow);
            i = j; // skip consumed sub-items
          } else if (a.dataset.sub !== '1') {
            var lnk2 = document.createElement('a');
            lnk2.href = a.getAttribute('href');
            lnk2.className = 'col-mega-nav-link' + (isLinkActive ? ' active' : '');
            lnk2.innerHTML = '<span class="col-mega-nav-arrow">›</span>'
                           + '<span class="col-mega-nav-label">' + a.textContent.trim() + '</span>';
            body.appendChild(lnk2);
            i++;
          } else {
            i++; // orphan sub — skip
          }
        }
        wrap.appendChild(body);
      }
      return wrap;
    }

    var frag = document.createDocumentFragment();
    if (activeGroup) frag.appendChild(buildItem(activeGroup, true));
    allGroups.forEach(function (g) { if (g !== activeGroup) frag.appendChild(buildItem(g, false)); });

    navEl.innerHTML = '';
    navEl.appendChild(frag);
    navEl.style.display = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildMegaNav);
  } else {
    buildMegaNav();
  }
})();

/* ── Mobile E-pood panel — built from hellyk-mega-data ───────────────────── */
(function () {
  function buildMobEpood() {
    var container = document.getElementById('mobEpoodBody');
    var dataEl    = document.getElementById('hellyk-mega-data');
    if (!container || !dataEl) return;

    var groups = Array.from(dataEl.querySelectorAll('.mega-sbd-group'));
    if (!groups.length) return;

    var frag = document.createDocumentFragment();

    groups.forEach(function (group) {
      var title = group.dataset.title;
      var url   = group.dataset.url;
      var links = Array.from(group.querySelectorAll('a'));
      var topLinks = links.filter(function (a) { return a.dataset.sub !== '1'; });

      var section = document.createElement('div');
      section.className = 'mob-epood-section';

      /* ── Section header button ── */
      var btn = document.createElement('button');
      btn.className = 'mob-epood-section-btn';
      btn.setAttribute('aria-expanded', 'false');

      var titleLink = document.createElement('a');
      titleLink.className = 'mob-epood-section-link';
      titleLink.href = url;
      titleLink.textContent = title;
      titleLink.addEventListener('click', function (e) { e.stopPropagation(); });
      btn.appendChild(titleLink);

      var children = null;

      if (topLinks.length) {
        /* chevron */
        var chevSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        chevSvg.setAttribute('class', 'mob-group-chevron');
        chevSvg.setAttribute('width', '13'); chevSvg.setAttribute('height', '13');
        chevSvg.setAttribute('viewBox', '0 0 24 24');
        chevSvg.setAttribute('fill', 'none');
        chevSvg.setAttribute('stroke', 'currentColor');
        chevSvg.setAttribute('stroke-width', '2.5');
        chevSvg.style.marginRight = '16px';
        var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        poly.setAttribute('points', '6 9 12 15 18 9');
        chevSvg.appendChild(poly);
        btn.appendChild(chevSvg);

        /* collapsible body */
        children = document.createElement('div');
        children.className = 'mob-group-children mob-epood-tag-wrap';
        children.style.maxHeight = '0';

        /* build links with sub-accordion logic */
        var i = 0;
        while (i < links.length) {
          var a = links[i];
          if (a.dataset.sub === '1') { i++; continue; }

          var hasSubs = a.dataset.hasSubs === '1';

          if (hasSubs) {
            let subLinks = [];
            let j = i + 1;
            while (j < links.length && links[j].dataset.sub === '1') {
              subLinks.push(links[j]);
              j++;
            }

            let parentRow = document.createElement('div');
            parentRow.className = 'mob-sub-parent';

            let mainLink = document.createElement('a');
            mainLink.href = a.getAttribute('href');
            mainLink.className = 'mob-epood-link';
            mainLink.innerHTML = '<span class="hdr-tag-arrow">›</span>'
                               + '<span class="hdr-tag-text">' + a.textContent.trim() + '</span>';
            parentRow.appendChild(mainLink);

            let subList = document.createElement('div');
            subList.className = 'mob-sub-list';
            subList.style.maxHeight = '0';
            subLinks.forEach(function (sa) {
              var sl = document.createElement('a');
              sl.href = sa.getAttribute('href');
              sl.className = 'mob-epood-link mob-sub-link';
              sl.innerHTML = '<span class="hdr-tag-arrow">–</span>'
                           + '<span class="hdr-tag-text">' + sa.textContent.trim() + '</span>';
              subList.appendChild(sl);
            });

            let expandBtn = document.createElement('button');
            expandBtn.className = 'mob-sub-expand';
            expandBtn.setAttribute('aria-expanded', 'false');
            expandBtn.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
            expandBtn.addEventListener('click', function (e) {
              e.stopPropagation();
              const isOpen = parentRow.classList.contains('mob-sub-open');
              /* close siblings */
              children.querySelectorAll('.mob-sub-parent.mob-sub-open').forEach(function (other) {
                if (other === parentRow) return;
                other.classList.remove('mob-sub-open');
                var ol = other.querySelector('.mob-sub-list');
                var ob = other.querySelector('.mob-sub-expand');
                if (ol) ol.style.maxHeight = '0';
                if (ob) ob.setAttribute('aria-expanded', 'false');
              });
              parentRow.classList.toggle('mob-sub-open', !isOpen);
              subList.style.maxHeight = isOpen ? '0' : subList.scrollHeight + 'px';
              expandBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
              children.style.maxHeight = children.scrollHeight
                + (isOpen ? 0 : subList.scrollHeight) + 'px';
            });

            parentRow.appendChild(expandBtn);
            parentRow.appendChild(subList);
            children.appendChild(parentRow);
            i = j;
          } else {
            var lnk = document.createElement('a');
            lnk.href = a.getAttribute('href');
            lnk.className = 'mob-epood-link';
            lnk.innerHTML = '<span class="hdr-tag-arrow">›</span>'
                          + '<span class="hdr-tag-text">' + a.textContent.trim() + '</span>';
            children.appendChild(lnk);
            i++;
          }
        }

        /* category accordion toggle */
        btn.addEventListener('click', function () {
          var isOpen = section.classList.contains('mob-open');
          /* close siblings */
          container.querySelectorAll('.mob-epood-section.mob-open').forEach(function (s) {
            if (s === section) return;
            s.classList.remove('mob-open');
            var sb = s.querySelector('.mob-epood-section-btn');
            var sc = s.querySelector('.mob-group-children');
            if (sb) sb.setAttribute('aria-expanded', 'false');
            if (sc) sc.style.maxHeight = '0';
          });
          section.classList.toggle('mob-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
          children.style.maxHeight = isOpen ? '0' : children.scrollHeight + 'px';
        });
      }

      section.appendChild(btn);
      if (children) section.appendChild(children);
      frag.appendChild(section);
    });

    container.appendChild(frag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildMobEpood);
  } else {
    buildMobEpood();
  }
})();
